import { computed, type Ref } from 'vue'
import { useHttp } from '@/shared/lib/http'
import { formatLocalWallClockVerDateNow } from '@/shared/lib'
import { useQuery } from '@tanstack/vue-query'

/**
 * Функция получения данных с сервера
 * @param data
 * @param filter
 */
export const useLoadListItem = (data: Ref<number>, filter: Ref<{ status_date: null | string }>) => {
  const http = useHttp()

  const url = computed(() => {
    const params: any = {
      object_ids: data.value.toString(),
    }

    if (filter.value.status_date) {
      params['status_date'] = filter.value.status_date
    } else {
      params['client_now'] = formatLocalWallClockVerDateNow()
    }

    const searchParams = new URLSearchParams(params)
    return `/inventory/objects/passport?${searchParams}`
  })

  const queryKey = computed(() => ['load_invent_list_item', url])

  return useQuery({
    queryKey,
    queryFn: () => http.get(url.value),
    retry: false,
  })
}
